import React, { createContext, useCallback, useEffect, useState } from 'react';
import { runCtmWhenReady } from '~/shared/lib/run-ctm';

export const GeoLocationContext = createContext(null);

export const GeoLocationProvider = ({ children }) => {
  let [location, setLocation] = useState('');

  const updateLocation = useCallback((locationValue) => {
    setLocation(locationValue);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    const id = window.requestAnimationFrame(() => {
      runCtmWhenReady();
    });
    return () => window.cancelAnimationFrame(id);
  }, [location]);

  return <GeoLocationContext.Provider value={{ location, updateLocation }}>{children}</GeoLocationContext.Provider>;
};

